'use client';
var classes = {"root":"m_8f2832ae","section":"m_7a0fe999"};

export { classes as default };
//# sourceMappingURL=NavigationProgress.module.css.mjs.map
